module.exports = __webpack_public_path__ + "static/media/stamp.7dcc469e.png";